import React from 'react';

const statuses = [
    { key: 'complete', label: 'Completed', dot: 'var(--green-color)' },
    { key: 'in-progress', label: 'In Progress', dot: '#f59e0b' },
    { key: 'blocked', label: 'Blocked', dot: 'var(--red-color, #d3281f)' },
    { key: 'not-started', label: 'Clear status', dot: 'var(--medium-light-grey-color)' },
];

const StatusSelector = ({ currentStatus, onChange, disabled }) => {
    return (
        <div className="cp-status-selector">
            <div className="cp-status-selector__label">STATUS</div>
            <div className="cp-status-selector__options">
                {statuses.map((s) => (
                    <button
                        key={s.key}
                        className={`cp-status-option ${currentStatus === s.key ? 'cp-status-option--active' : ''}`}
                        onClick={() => !disabled && onChange?.(s.key)}
                        disabled={disabled}
                    >
                        <span className="cp-status-option__dot" style={{ background: s.dot }} />
                        {s.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default StatusSelector;
